import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');
//constantes
const dataInicial = {
    data: {},
    fc_35: {
        fechapropuestaactividad: fechaHoy,
        fechasolicitud: fechaHoy,
        numerocliente: '',
        nombrerazonsocial: '',
        tipoinstalacion: '',
        nombreresponsable: '',
        correoelectronico: '',
        telefono: '',
        domicilio: '',

        ajusteetiquetado: false,
        ventanacional: false,
        ventaexportacion: false,
        servicioajuste: '',

        gestiontramites: false,
        gestionautorizacion: false,
        gestionconvenio: false,
        registromarca: false,
        renovacionmarca: false,
        licenciamarca: false,
        transmicionderechos: false,
        serviciogestion: '',

        paquetecofepris: false,
        avisofuncionamiento: false,
        padronbebidas: false,
        padronsectorial: false,
        marbetes:false,
        serviciopaquete: '',

        /*analisispreliminar: false,
        alcoholvolumen: false,
        extractoseco: false,
        alcoholesuperiores: false,
        metanol: false,
        furfural: false,
        aldehidos: false,
        plomo: false,
        arsenico: false,
        servicioanalisis: '',*/

        solicitudbitacoras:false,
        bitacoraproduccion:false,
        bitacoraenvasado:false,
        bitacoracomercializador:false,
        produccionmezcal:false,
        mezcalancestral:false,
        mezcal:false,
        envasado:false,
        comercializador:false,
        serviciosolicitud:'',

        otrosservicios:false,
        serviciootros:'',
    },
    loading: false,
    fc_35Map: {},
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    dataLogin: [],
    files: [],
    dataDocumentacion: {},
    filesMap: [],
    domicilios:[],
}

//types
const OBTENER_CLIENTE_POR_LOGIN_EXITO_35 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_35'
const AGREGAR_FC_35_EXITO = 'AGREGAR_FC_35_EXITO'
const OBTENER_FC_35_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_35_CONTADOR_FECHA_FOLIO_EXITO'
const AGREGAR_FC_35_FECHA_EXITO = 'AGREGAR_FC_35_FECHA_EXITO'
const AGREGAR_ARCHIVO_FC_35_EXITO = 'AGREGAR_ARCHIVO_FC_35_EXITO'
const ACTUALIZAR_ARCHIVO_FC_35_EXITO = 'ACTUALIZAR_ARCHIVO_FC_35_EXITO'
const OBTENER_FC_35_DETALLE_PARA_DOCUMENTACION_EXITO = 'OBTENER_FC_35_DETALLE_PARA_DOCUMENTACION_EXITO'
const AGREGAR_FC_35_BORRADOR_EXITO = 'AGREGAR_FC_35_BORRADOR_EXITO'



const ACTUALIZAR_FC_35_ESTATUS_EXITO = 'ACTUALIZAR_FC_35_ESTATUS_EXITO'
const ELIMINAR_FC_35_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_35_SOLICITUD_EXITO_BD'
const OBTENER_FC_35_MAP_EXITO = 'OBTENER_FC_35_MAP_EXITO'
const OBTENER_FC_35_DETALLE_EXITO = 'OBTENER_FC_35_DETALLE_EXITO'

export const ObtenerClientePorLogin35 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_35,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            let fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            let fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            let fullUrlDomicilioCliente = host + `InformacionValida/obtenerDomicilioFiscalClientePorCliente/${idcliente}`

            let resinstalaciones = await axios.get(fullUrlInstalaciones)
            let resdomicilio = await axios.get(fullUrlDomicilioCliente)

            let datos = []
            let instalaciones = []
            let dat = []
            dat.push(resdomicilio.data.data)
            let onjUnidos = [...resinstalaciones.data.data, ...dat];
            instalaciones.push(onjUnidos)
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_35_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFC_35Accion = createAsyncThunk(
    AGREGAR_FC_35_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_35/agregarFormatoFC35`
            const res = await axios.post(fullUrl, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_35Fecha = createAsyncThunk(
    AGREGAR_FC_35_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_35 = host + `FC_35/actualizarFormatoFC35`
            const res = await axios.put(actualizarFC_35, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFileFC_35 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_35_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_35 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_35_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const obtenerFC_35SolicitudDetalleParaDocumentacion = createAsyncThunk(
    OBTENER_FC_35_DETALLE_PARA_DOCUMENTACION_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_35/obtenerFormatoFC35_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)

            const documentosFC_35 = []
            //FILES
            for (const i in res.data.data.fc_35archivos) {
                const { ...anexo } = res.data.data.fc_35archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_35archivos,
                    idAnexoFK: res.data.data.idfc35_notificacionserviciosvar,
                    estatus: true,
                }
                documentosFC_35.push(data)
            }
            if (res.data.data.fechapropuestaactividad) {
                let fecha = res.data.data.fechapropuestaactividad
                res.data.data.fechapropuestaactividad = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }
            return { data: res.data.data, documentosFC_35 }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const actualizarFC_35SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_35_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data }

            const agregarFC_35 = host + `FC_35/actualizarFormatoFC35`
            const res = await axios.put(agregarFC_35, solicitud)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_35SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_35_SOLICITUD_EXITO_BD,
    async (idfc35_notificacionserviciosvar) => {
        try {
            
            const fullUrlSolicitud = host + `FC_35/eliminarFormatoFC35/${idfc35_notificacionserviciosvar}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return resultDelete
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_35Map = createAsyncThunk(
    OBTENER_FC_35_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_35_NotificacionDeServiciosVariosMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            const Map = await obtenerAchivosMap(solicitudId)
            return { data: res.data.data, filesMap: Map.filesGeneralMap }
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerAchivosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_35/obtenerFormatoFC35_ConDetalle/${idSolicitud}`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_35_ArchivosGenerales/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_35archivos
        const filesGeneralMap = []

        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_35archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_35archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }
        let Map = { filesGeneralMap: filesGeneralMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}

export const actualizarFC_35Estatus = createAsyncThunk(
    ACTUALIZAR_FC_35_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc35Slice = createSlice({
    name: 'fc35Slice',
    initialState: dataInicial,
    reducers: {
        agregarDomicilios(state, { payload }) {
            state.instalacionesCliente = payload
        },
        actualizarModoBorradorFC_35(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarFC_35PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        setCambiosFC_35SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        setCambiosFC_35SolicitudNueva(state, { payload }) {
            state.fc_35 = payload
        },
        resetDataFC_35(state, { payload }) {
            return dataInicial
        },
        setModoCorrecionFC_35(state, { payload }) {
            state.modoCorreccion = payload
        }
    },
    extraReducers: {
        [ObtenerClientePorLogin35.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            //state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
            state.domicilios = payload[1][0]
        },
        [obtenerFC_35SolicitudDetalleParaDocumentacion.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_35 = payload.data
            state.dataDocumentacion = payload.data
            state.files = { data: payload.documentosFC_35 }
        },
        [actualizarFC_35SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },




        [agregarFC_35Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_35Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_35SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        
        [obtenerFC_35Map.fulfilled]: (state, { payload }) => {
            state.fc_35Map = payload?.data
            state.filesMap = payload?.filesMap
        }

    }
})


export const { setCambiosFC_35SolicitudBorrador,
    setCambiosFC_35SolicitudNueva,
    actualizarFC_35PaginaActiva,
    resetDataFC_35,
    actualizarModoBorradorFC_35,agregarDomicilios,
    setModoCorrecionFC_35 } = fc35Slice.actions
export const FC35ReducerBeneficiario = fc35Slice.reducer
